export async function getCsrfToken(): Promise<string> {
  const res = await fetch('/api/auth/csrf').then(a => a.json())

  if (typeof res?.csrf !== 'string') throw new Error('Invalid CSRF type')
  return res.csrf
}
